import api from '@/api'
import utils from '@/utils/utils'
// import $ from 'jquery'

export default {
  data () {
    return {
      classData: {},
      subClassesMap: {},
      overdueSubsMap: {},
      userClasses: [],
      userSubclasses: [],
      groupBuyInfo: {},
      weeks: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    }
  },
  created () {
    if (this.$route.params.classType === 'live') {
      this.fetchUserSubclasses()
    }
  },
  methods: {
    fetchUserSubclasses () {
      api.getUserSubclass({ class_id: this.$route.params.classId, goods_type: 2 }).then(res => {
        if (res.data.code === 1) {
          this.userSubclasses = res.data.items || []
        }
      })
    },
    handleClassData (classData) {
      const details = this.getDetailClass(this.basicClassData(classData))
      details.subclasses = details.subclass
      delete details.subclass
      classData.subclasses = this.processSubclass(details.subclasses, {
        vipDeadline: this.processDeadlineAt(details)
      })
      details.isNeedBook = this.isNeedBook(details.price, details.subclasses)
      return details
    },
    basicClassData (classData) {
      var now = new Date().getTime() / 1000
      var beginDateISO = new Date(classData.begin_at * 1000 + 28800000)
      var endDateISO = new Date(classData.end_at * 1000 + 28800000)
      var subclass = classData.subclass || classData.subclasses
      var round = ''
      var season = ''
      classData.module_name = classData.module_name || ''
      classData.stick = classData.sort > 0 ? 'stick' : ''
      classData.cover = classData.cover || '//cdn.eduzhixin.cn/cdn/img/live/default-cover.png'
      classData.voice_intro = classData.voice_intro || ''
      classData.beginDate = beginDateISO.toISOString().slice(0, 10).replace(/-/g, '.')
      classData.endDate = endDateISO.toISOString().slice(0, 10).replace(/-/g, '.')
      classData.teachers = classData.teachers ? classData.teachers + '' : ''
      classData.teachers_info = this.resetTeachersInfo(classData.teachers_info)
      classData.materials_info = classData.material_info
      classData.isShowLianbao = this.getLianbaoInfo(classData).isShowLianbao
      classData.addCartBtn = this.generateAddCartBtn(classData)
      // group_setting 大课列表
      if (classData.group_setting) {
        classData.group_set = classData.group_setting.group_set
        classData.group_end_time = classData.group_setting.group_end_time
        classData.group_price = classData.group_setting.group_price
      }
      if (classData.group_end_time) {
        classData.groupBuy = classData.group_set === 1 && (new Date().getTime() / 1000 - classData.group_end_time < 0)
      } else {
        classData.groupBuy = classData.group_set === 1
      }
      switch (true) {
        case now < classData.begin_at:
          classData.statusName = '未开始'
          classData.status = 0
          break
        case now > classData.begin_at && now < classData.end_at:
          classData.statusName = '进行中'
          classData.processing = ''
          classData.status = 1
          break
        case now > classData.end_at:
          classData.statusName = '已结束'
          classData.status = 2
          break
      }
      if (subclass) {
        classData.processing = this.getClassProcessing(subclass, {
          status: classData.status,
          begin_at: classData.begin_at
        }).processing
      }
      if (classData.panel_labels && classData.panel_labels.length !== 0) {
        classData.panel_labels.forEach((obj) => {
          if (!round && obj.label_type === 'round') {
            round = obj.label_name
          }
          if (!season && obj.label_type === 'season') {
            season = obj.label_name
          }
        })
        classData.round = round
        classData.season = season
      }
      return classData
    },
    getDetailClass (classData) {
      var freeClassLen = 0
      var purchasedSub = 0
      let needPrice = 0
      var _this = this
      // var liveLabelsType = _this.get('liveLabelsType')
      if (classData.quota === 0 || classData.quota - classData.ordered === 0) {
        classData.quotaText = '名额已满'
      } else if ((classData.ordered / classData.quota) > 0.8) {
        classData.quotaText = '报名人数&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + classData.ordered + '/' + classData.quota
      } else if (classData.ordered < 50) {
        classData.quotaText = '火热报名中'
      } else {
        classData.quotaText = '报名人数&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + classData.ordered
      }
      classData.processing = _this.getClassProcessing(classData.subclass, {
        status: classData.status,
        begin_at: classData.begin_at
      })
      // classData.labelTexts = classData.labels.map((lab) => {
      //   // eslint-disable-next-line no-prototype-builtins
      //   if (liveLabelsType && liveLabelsType.hasOwnProperty(lab.id)) {
      //     return liveLabelsType[lab.id].label_name
      //   }
      // })
      var isVip = this.getVipAuth(classData)
      classData.purchased = this.IsPurchasedClass(classData.class_id) || isVip
      classData.subclass.forEach((sub) => {
        if (Number(sub.price) === 0) {
          freeClassLen += 1
        } else {
          var res = _this.isPurchasedSubclass(classData.class_id, sub.subclass_id)
          sub.purchased = isVip || res.purchased
          if (sub.purchased) {
            purchasedSub += 1
          } else {
            needPrice += sub.price
          }
        }
      })
      classData.needPrice = needPrice
      classData.purchasedSub = purchasedSub
      classData.needPurchasedSub = classData.subclass.length - freeClassLen
      classData.subclass_group_info && classData.subclass_group_info.forEach(el1 => {
        classData.subclass.forEach(el2 => {
          if (el1.subclass_id === el2.subclass_id) {
            for (var i in el1) {
              el2[i] = el1[i]
            }
          }
        })
      })

      // free live
      classData.isAllBooked = this.isAllBooked(classData.price, classData.subclass)
      classData.disabled = ''
      classData.hasPurchasedAllSub = false
      classData.groupBuy = false
      classData.inShareState = false

      if (classData.group_end_time) {
        classData.groupBuy = classData.group_set === 1 && (new Date().getTime() / 1000 - classData.group_end_time < 0)
      } else {
        classData.groupBuy = classData.group_set === 1
      }
      if (Number(classData.price) === 0) {
        classData.actionClass = 'unchecked book-lg'
        classData.action = '立即预约'
      } else if (Number(classData.online) === 0) {
        const isAdmin = this.userInfo.role === 1
        classData.action = '课程已下线'
        if (isVip && isAdmin) {
          classData.actionClass = 'disabled'
          classData.disabled = 'disabled = disabled'
          classData.action = '已下线'
        }
        if (isVip && !isAdmin) {
          classData.actionClass = 'disabled'
          classData.disabled = 'disabled = disabled'
          classData.action = ''
        }
      } else if (classData.needPurchasedSub === classData.purchasedSub && classData.purchasedSub !== 0) {
        classData.actionClass = 'disabled'
        classData.disabled = 'disabled = disabled'
        classData.action = '已报名此课程'
      } else if (classData.purchasedSub > 0 || classData.purchased) {
        classData.actionClass = 'unchecked'
        classData.action = '报名剩余章节(' + (classData.subclass.length - classData.purchasedSub) + ')'
      } else {
        classData.actionClass = 'unchecked'
        classData.action = '立报此课程'
      }
      classData.hasPurchasedAllSub = (classData.needPurchasedSub === classData.purchasedSub && classData.purchasedSub !== 0) || isVip
      classData = this.getGroupBuyInfo(classData)
      classData.addCartBtn = this.generateAddCartBtn(classData)
      if (classData.addCartBtn && classData.addCartBtn.includes('联报')) {
        classData.actionBtn = classData.action && '<button class="btn-md btn-success btn-before-union ' + classData.actionClass +
          '" data-price="' + (classData.price / 100).toFixed(2) + '" data-id="' + classData.class_id +
          '" ' + classData.disabled + '>' + classData.action + '</button>'
      } else {
        classData.actionBtn = classData.action && '<button class="btn-md btn-success ' + classData.actionClass +
          '" data-price="' + (classData.price / 100).toFixed(2) + '" data-id="' + classData.class_id +
          '" ' + classData.disabled + '>' + classData.action + '</button>'
      }

      this.classData = classData
      return classData
    },
    isAllBooked (totalPrice, subclasses) {
      if (totalPrice > 0) {
        return false
      }
      const length = subclasses.length || 0
      for (let i = 0; i < length; i++) {
        const booked = !!subclasses[i].booked_mobile
        if (booked) {
          return true
        }
      }
      return false
    },
    getGroupBuyInfo (classData) {
      const res = this.groupBuyInfo
      if (res.data.code === 1) {
        classData.inShareState = !!(!classData.hasPurchasedAllSub && res.data.user_group && res.data.user_group.group_state === 1)
        if (res.data.items.length > 0) {
          res.data.items.forEach(el => {
            el.members_info.sort(function (a, b) {
              return a.create_at - b.create_at
            })
          })
        }
        classData.groupsInfo = res.data.items
        classData.user_group = res.data.user_group
      } else {
        classData.groupsInfo = []
        classData.user_group = null
      }
      return classData
    },
    IsPurchasedClass (classId) {
      if (this.userInfo.role === 1) {
        return true
      }
      let tempIndex = -1
      this.userClasses.forEach((item, index) => {
        if (Number(item.class_id) === Number(classId)) {
          tempIndex = index
        }
      })
      return tempIndex > -1
    },
    isPurchasedSubclass (classId, subclassId) {
      let deadlineAt = 0
      if (this.userInfo.role === 1) {
        return {
          purchased: true,
          deadline_at: deadlineAt
        }
      }
      const subclass = this.userSubclasses.filter(item => Number(item.subclass_id) === Number(subclassId))[0]
      if (subclass && subclass.deadline_at) {
        deadlineAt = subclass.deadline_at
      }
      if (subclass) {
        return {
          purchased: true,
          deadline_at: deadlineAt
        }
      }
      return {
        purchased: false,
        deadline_at: deadlineAt
      }
    },
    resetTeachersInfo (items) {
      const defaultPictures = ['//cdn.eduzhixin.cn/cdn/img/live/teacher-nan.png', '//cdn.eduzhixin.cn/cdn/img/live/teacher-nv.png']
      return items.map((item) => {
        const defaultPicture = defaultPictures[item.gender === 2 ? 1 : 0]
        return {
          teacher_name: item.teacher_name,
          unique_name: item.unique_name,
          picture: item.picture || defaultPicture
        }
      })
    },
    userLiveOverdued (purchased, deadlineAt) {
      if (purchased && deadlineAt) {
        return utils.timeToString(deadlineAt)
      }
      return false
    },
    getLianbaoInfo (classData) {
      const {
        activity_type: type,
        activity_info: info
      } = classData
      const cartSwitchUnion = this.userInfo.cart_switch_union
      if (cartSwitchUnion === false) {
        return {
          isLianbao: false,
          isShowLianbao: false
        }
      }
      const isEnded = info && info.end_at < (+new Date() / 1000)
      const hasBeginned = info && info.begin_at < (+new Date() / 1000)
      const isShowLianbao = hasBeginned && cartSwitchUnion
      const isLianbao = !isEnded && type === 2 && cartSwitchUnion
      return {
        isLianbao,
        isShowLianbao
      }
    },
    proccessBtns (subclass) {
      var now = new Date().getTime()
      var begin = new Date(subclass.begin_at * 1000)
      var end = new Date(subclass.end_at * 1000)
      var preBegin = subclass.begin_at * 1000 - 1800000
      var aftEnd = subclass.end_at * 1000 + 1800000
      var canIn = now >= preBegin
      const isVip = this.getVipAuth(subclass)
      subclass.overdueAt = subclass.deadline_at || 0
      subclass.booked = subclass.booked_mobile ? '1' : '0'
      subclass.week = this.weeks[begin.getDay()]
      subclass.date = (begin.getMonth() + 1) + '月' + begin.getDate() + '日' +
        begin.toTimeString().slice(0, 5) + '-' +
        end.toTimeString().slice(0, 5)
      subclass.overdueDate = this.userLiveOverdued(subclass.purchased || subclass.price === 0, subclass.deadline_at)
      if (now < preBegin) {
        // 开始前30分钟之前
        subclass.status = 0
        subclass.statusName = '未开始'
        if (subclass.price === 0) {
          subclass.canBooking = !(subclass.purchased || subclass.booked === '1')
          subclass.action = subclass.canBooking ? '' : '已预约'
          subclass.actionBtn = subclass.canBooking ? 'btn-success-ghost' : 'btn-success disabled'
          subclass.orderBtn = subclass.canBooking ? 'order-sub' : 'enter-tip'
          subclass.bookedLabel = ''
          if (!subclass.purchased) {
            if (Number(subclass.booked) === 0) {
              subclass.bookedLabel = '<label class="label">未预约</label>'
              subclass.bookedStatus = ''
            } else {
              subclass.bookedLabel = '<label class="label">已预约</label>'
              subclass.bookedStatus = '已预约'
            }
          }
        } else {
          subclass.action = subclass.purchased ? '进入直播' : '立即报名'
          subclass.actionBtn = subclass.purchased ? 'btn-success disabled' : '' + 'btn-success-ghost'
          subclass.orderHref = ''
          subclass.orderBtn = subclass.purchased ? 'enter-tip' : ''
        }
      } else if (now < begin.getTime()) {
        // 开始前的30分钟
        subclass.status = 1
        subclass.statusName = '即将开始'
        subclass.action = (subclass.purchased || subclass.price === 0) ? '进入直播' : '立即报名'
        subclass.actionBtn = (subclass.purchased || subclass.price === 0) ? 'btn-success' : '' + 'btn-success-ghost'
      } else if (now > aftEnd) {
        // 结束30分钟之后
        subclass.status = 2
        subclass.statusName = '已结束'
        if (subclass.purchased) {
          if (isVip) {
            subclass.action = '看回放'
            subclass.actionBtn = 'btn-success'
          } else {
            subclass.action = '看回放'
            subclass.actionBtn = 'btn-success'
            if (subclass.overdueAt !== 0 && now >= subclass.overdueAt * 1000) {
              subclass.action = '已过期'
              subclass.actionBtn = 'btn-success overdue'
              this.overdueSubsMap[subclass.subclass_id] = {
                chargeAt: Math.max(subclass.charge_at, subclass.end_at),
                overdueAt: subclass.overdueAt
              }
            }
          }
        } else {
          subclass.action = subclass.price === 0 ? '看回放' : '立即报名'
          subclass.actionBtn = subclass.price === 0 ? 'btn-success' : '' + 'btn-success-ghost'
          if (subclass.overdueAt !== 0 && now >= subclass.overdueAt * 1000) {
            if (subclass.price === 0) {
              subclass.action = '已过期'
              subclass.actionBtn = 'btn-success overdue'
            }
            this.overdueSubsMap[subclass.subclass_id] = {
              chargeAt: subclass.end_at,
              overdueAt: subclass.overdueAt
            }
          }
        }
      } else if (now > end.getTime()) {
        // 结束
        subclass.status = 1
        subclass.statusName = '直播中'
        subclass.action = (subclass.purchased || subclass.price === 0) ? '进入直播' : '立即报名'
        subclass.actionBtn = (subclass.purchased || subclass.price === 0) ? 'btn-success' : '' + 'btn-success-ghost'
      } else {
        subclass.status = 1
        subclass.statusName = '直播中'
        subclass.action = (subclass.purchased || subclass.price === 0) ? '进入直播' : '立即报名'
        subclass.actionBtn = (subclass.purchased || subclass.price === 0) ? 'btn-success' : '' + 'btn-success-ghost'
      }
      if (Number(subclass.replay_id) === 1) {
        subclass.replayLabel = '<label class="label">录像</label>'
      } else {
        subclass.replayLabel = '<label class="label status-ongoing">直播</label>'
      }
      if ((subclass.purchased || Number(subclass.price) === 0) && canIn) {
        subclass.href = '#live/' + subclass.class_id + '/' + subclass.subclass_id
        if (!this.isLogin) {
          subclass.href = '?from=welcome' + subclass.href
        }
      } else {
        if (subclass.action === '立即报名') {
          subclass.href = '#livereg/' + subclass.class_id
          if (!this.isLogin) {
            subclass.href = '?from=welcome' + subclass.href
          }
        } else {
          subclass.href = 'javascript:void(0)'
        }
      }
      if (now > aftEnd && (subclass.purchased || Number(subclass.price) === 0)) {
        // 当 非管理员 且 过期时间不等于0 且 已经过期，不可看回放
        if (subclass.overdueAt !== 0 && now / 1000 > subclass.overdueAt && !isVip) {
          subclass.href = 'javascript:void(0)'
        } else {
          subclass.href += '/replay'
        }
      }
      return {
        href: subclass.href,
        status: subclass.status,
        statusName: subclass.statusName,
        action: subclass.action,
        actionBtn: subclass.actionBtn,
        canBooking: subclass.canBooking,
        orderBtn: subclass.orderBtn,
        bookedLabel: subclass.bookedLabel,
        bookedStatus: subclass.bookedStatus
      }
    },
    getClassProcessing (subclasses, more) {
      var _this = this
      var started = 0
      var overed = 0
      var processing = ''
      var classStatus = more.status
      if (classStatus === 0) {
        more.beginDate = utils.convertTimeFormat(more.begin_at, 0, 10, '.')
        processing = '课程进度：' + more.beginDate + ' 开课'
        return {
          overed: overed,
          started: started,
          processing: processing
        }
      }
      if (classStatus === 2) {
        processing = '课程进度：已结束'
        return {
          overed: subclasses.length || overed,
          started: started,
          processing: processing
        }
      }
      subclasses.forEach(function (subclass, index) {
        subclass = _this.proccessBtns(subclass)
        started = subclass.statusName === '直播中' ? started + 1 : started
        overed = subclass.statusName === '已结束' ? overed + 1 : overed
        if (classStatus === 1) {
          processing = subclass.statusName === '直播中' ? '课程进度：正在直播第' + (index + 1) + '次课' : '课程进度：下次直播第' + (overed + 1) + '次课'
        }
      })
      return {
        overed: overed,
        started: started,
        processing: processing
      }
    },
    getVipAuth (data = {}) {
      // if (!this.isLogin) {
      //   return false
      // }
      // var isVipAuth = false
      // var now = $.now() / 1000
      // if (data.year_vip_can_watch !== undefined) {
      //   isVipAuth = data.year_vip_can_watch === true
      // } else {
      //   const res = this.userInfo.vip_plus.filter(function (item) {
      //     return item.subject === data.subject_type
      //   })
      //   isVipAuth = res.length ? (res[0].end_at > now) && ((res[0].begin_at <= now)) : false
      // }
      // return this.userInfo.role === 1 || isVipAuth
      // 判断条件  getUserSubclass返回数据并且等于大课的小课数量(只要有一个小课有效期时间小于当前时间就不是会员)
      let classLength = 0
      let subDeadlineState = false
      const nowTime = parseInt(new Date().getTime() / 1000)
      if (this.classData && this.classData.subclasses) {
        classLength = this.classData.subclasses.length
        subDeadlineState = this.classData.subclasses.every(item => {
          return item.deadline_at > nowTime
        })
      }
      const subclassLength = (this.userSubclasses || []).length
      return subclassLength > 0 && classLength === subclassLength && subDeadlineState
      // return false
    },
    processSubclass (subclasses, options = {}) {
      var _this = this
      subclasses.forEach(function (subclass, index) {
        _this.toNumber(subclass, false)
        _this.subClassesMap[subclass.subclass_id] = subclass.class_id
        subclass.cover = subclasses.cover
        subclass.regStatus = subclass.purchased ? '已报名' : '未报名'
        subclass.regStatus = Number(subclass.price) === 0 ? '' : subclass.regStatus
        subclass.regStatusLabel = Number(subclass.price) === 0 ? '' : '<label class="label">' + subclass.regStatus + '</label>'
        subclass.priceText = Number(subclass.price) === 0 ? '免费' : '￥' + Number((subclass.price / 100).toFixed(2))
        subclass.index = index - (-1)
        subclass.chargeAt = subclass.charge_at || 0
        if (options.vipDeadline) {
          subclass.deadline_at = options.vipDeadline
        }
        _this.proccessBtns(subclass)
      })
      return subclasses
    },
    isNeedBook (totalPrice, subclasses) {
      if (totalPrice > 0) {
        return false
      }
      const length = subclasses.length || 0
      for (let i = 0; i < length; i++) {
        const booked = !!subclasses[i].booked_mobile
        const notStard = subclasses[i].status === 0
        if (!booked && notStard) {
          return true
        }
      }
      return false
    },
    toNumber (classData, big) {
      classData.begin_at = Number(classData.begin_at)
      classData.end_at = Number(classData.end_at)
      classData.class_id = Number(classData.class_id)
      classData.price = Number(classData.price)
      if (big) {
        classData.online = Number(classData.online)
        classData.ordered = Number(classData.ordered)
        classData.quota = Number(classData.quota)
      } else {
        classData.subclass_id = Number(classData.subclass_id)
        if (classData.user_subclass && classData.user_subclass.length > 0) {
          classData.user_subclass.state = Number(classData.user_subclass.state)
          classData.user_subclass.subclass_id =
            Number(classData.user_subclass.subclass_id)
        }
      }
    },
    processDeadlineAt (classData) {
      // if (!this.isLogin) {
      //   return 0
      // }
      // const inVip = this.getVipAuth(classData) && this.userInfo.role !== 1
      // if (inVip) {
      //   const res = this.userInfo.vip_plus.filter(function (item) {
      //     return item.subject === classData.subject_type
      //   })
      //   return res[0].end_at
      // } else {
      //   return 0
      // }
      return 0
    },
    generateAddCartBtn (classData) {
      // 开启团购的情况下， 非团购课程的付费课拥有按钮
      const isGroup = classData.group_set === 1 || (!!classData.group_setting && classData.group_setting.group_set > 0)
      const isVip = this.getVipAuth(classData)
      if (isVip) {
        return ''
      }
      if (this.userInfo.grayscale_test && classData.price > 0 && !isGroup) {
        if (classData.cart_exist) {
          return '<button class="btn-md btn-success-ghost btn-add-cart" disabled>已加入购课单</button>'
        } else {
          const text = (classData.purchasedSub > 0 || classData.purchased) ? '剩余章节加入购课单' : '加入购课单'
          if (this.getLianbaoInfo(classData).isShowLianbao) {
            const str = classData.activity_info.discount_type === 1 ? '<i class="left-gradient"></i> 联报' + Number(classData.activity_info.discount_val / 10) + '折 <i class="right-gradient"></i>' : '<i class="left-gradient"></i> 联报直减' + Number((classData.activity_info.discount_val / 100).toFixed(2)) + ' <i class="right-gradient"></i>'
            return `<button class="btn-md btn-success-ghost btn-add-cart btn-with-union">${text}<span>${str}</span></button>`
          } else {
            return `<button class="btn-md btn-success-ghost btn-add-cart">${text}</button>`
          }
        }
      } else {
        return ''
      }
    }
  }
}
